import React, {MouseEvent} from "react"
import Box from "./Box";
import styles from '../css/Image.module.css'
import Icon from "./Icon";
import icons from "../css/Icon.module.css";

export interface Props {
    src?: string,
    alt?: string,
    onClick?: (event: MouseEvent) => void
    onError?: () => void,
    onLoad?: () => void,
    width?: number,
    minWidth?: number,
    minHeight?: number,
    isPreview?: boolean,
    objectFit?: "-moz-initial" | "inherit" | "initial" | "revert" | "unset" | "none" | "contain" | "cover" | "fill" | "scale-down" | undefined,
    height?: number,
    className?: string
}

export default (props: Props) => {

    const {src, isPreview, onError, onLoad, onClick, className, alt, width, minWidth, minHeight, height, objectFit} = props;

    return (
        <Box center className={className}>

            <div onClick={onClick} style={{width, height, minWidth, minHeight}}>
                {
                    src &&
                    <img onError={onError} src={src} alt={alt} onLoad={onLoad}
                      style={{
                          width,
                          height,
                          minWidth,
                          minHeight,
                          maxWidth: '100%',
                          objectFit: objectFit || 'contain'
                      }}/>
                }
                {
                    !src && !isPreview &&
                    <div className={styles.imageEditable} style={{width, minWidth, height, minHeight}}>
                        <Icon size={(width || minWidth || 0) * 0.26} lightGray name={icons.iconPhoto}/>
                    </div>
                }
            </div>

        </Box>
    );
}
